import { defaultRegion } from "common/config";
import React, { useState } from "react";

type CustomCoordinates = {
  latitude: number;
  longitude: number;
  accuracy?: number;
  altitude?: number | null;
  altitudeAccuracy?: number | null;
  heading?: number | null;
  speed?: number | null;
};

export function useGeoLocation() {
  const [location, setLocation] = useState<CustomCoordinates | null>(null);
  const [error, setError] = React.useState<string | null>(null);
  const [loading, setLoading] = React.useState(true);

  React.useEffect(() => {
    if (!navigator.geolocation) {
      setError("Geolocation is not supported.");
      setLoading(false);
      return;
    }
    console.log("Loading location....");
    navigator.geolocation.getCurrentPosition(
      (position) => {
        console.log("Location Loaded");
        setLocation(position.coords);
        setLoading(false);
      },
      (err) => {
        console.log("Error while loading location", err);
        setError(err.message);
        setLoading(false);
        //if there is some error
        //or if user doesn't allow location
        //set location london
        setLocation({
          latitude: defaultRegion.latitude,
          longitude: defaultRegion.longitude,
          accuracy: 0,
          altitude: null,
          altitudeAccuracy: null,
          heading: null,
          speed: null,
        });
      },
      {
        enableHighAccuracy: true,
        timeout: 5000,
        maximumAge: 0,
      }
    );
  }, []);

  const requestUserLocation = () => {
    setLoading(true);
    setError(null);
    navigator.geolocation.getCurrentPosition(
      (position) => {
        setLoading(false);
        setLocation(position.coords);
      },
      (err) => {
        setLoading(false);
        setError(err.message);
      },
      {
        enableHighAccuracy: true,
        timeout: 5000,
        maximumAge: 0,
      }
    );
  };
  return { location, error, loading, requestUserLocation };
}
